import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="svg7384" width="1em" height="1em" {...props}><title id="title9167">{"Gnome Symbolic Icon Theme"}</title><defs id="defs7386"><linearGradient id="linearGradient7212"><stop style={{
          stopColor: "#000000",
          stopOpacity: 1
        }} offset={0} id="stop7214" /></linearGradient></defs><g transform="translate(-341.0002,-13.000323)" style={{
      display: "inline"
    }} id="layer9" /><g transform="translate(-100,-380.00032)" id="layer1" /><g transform="translate(-100,-380.00032)" style={{
      display: "inline"
    }} id="layer10"><path d="m 108,382 a 8,8 0 0 0 -7.73828,6.00977 A 8,8 0 0 0 108,394 8,8 0 0 0 115.73828,387.99023 8,8 0 0 0 108,382 Z m 0,2 a 4,4 0 0 1 4,4 4,4 0 0 1 -4,4 4,4 0 0 1 -4,-4 4,4 0 0 1 4,-4 z" id="path2314" style={{
        opacity: 1,
        vectorEffect: "none",
        fill: "#2e3436",
        fillOpacity: 1,
        stroke: "none",
        strokeWidth: 1.5,
        strokeLinecap: "butt",
        strokeLinejoin: "round",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeDashoffset: 0,
        strokeOpacity: 1,
        marker: "none",
        markerStart: "none",
        markerMid: "none",
        markerEnd: "none",
        paintOrder: "normal"
      }} /><path id="path2318" d="m 110,388.00003 a 2,2 0 0 1 -2,2 2,2 0 0 1 -2,-2 2,2 0 0 1 2,-2 2,2 0 0 1 2,2 z" style={{
        vectorEffect: "none",
        fill: "#2e3436",
        fillOpacity: 1,
        stroke: "none",
        strokeWidth: 1,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeOpacity: 1
      }} /></g><g transform="translate(-100,-380.00032)" id="g6387" /><g transform="translate(-100,-380.00032)" id="layer11" /></svg>;
}

export default SvgComponent;